<template>
  <div>
    <headerStyle></headerStyle>
    <homePageStyle v-if="$route.name=='Home'"></homePageStyle>
    <loginStyle v-if="$route.name=='Login'"></loginStyle>
    <!-- <pricingPageStyle v-if="$route.name=='pricing'"></pricingPageStyle> -->
    <contactUsPageStyle v-if="$route.name=='Connect'"></contactUsPageStyle>
    <resetPassword v-if="$route.name=='Resetpassword'"></resetPassword>
    <newPassword v-if="$route.name=='new-password'"></newPassword>
    <signUpPageStyle v-if="$route.name=='Register'"></signUpPageStyle>
    <classRoomsteacher v-if="$route.name=='classrooms'"></classRoomsteacher>
    <classRoomsDetailsTeacher v-if="$route.name=='classrooms-details'"></classRoomsDetailsTeacher>
    <progressAssessment v-if="$route.name=='progress-assessment'"></progressAssessment>
    <codeAssessment v-if="$route.name=='code-assessment'"></codeAssessment>
    <schoolTeachers v-if="$route.name=='teachers'"></schoolTeachers>
    <schoolStudent v-if="$route.name=='students'"></schoolStudent>
    <questionsPage v-if="$route.name=='Questions' || $route.name=='Lessonprevideo'"></questionsPage>
    <ideStyle v-if="$route.name=='Ide'"></ideStyle>
    <lessonPrevideo v-if="$route.name=='Lessonprevideo' || $route.name=='story'"></lessonPrevideo>
    <manageMyKids v-if="$route.name=='profile'"></manageMyKids>
    <memberShip v-if="$route.name=='memberShip'"></memberShip>
    <renewSubscription v-if="$route.name=='renewSubscription'"></renewSubscription>
    <studentProfile v-if="$route.name=='student-profile'"></studentProfile>
    <studentProfile v-if="$route.name=='Studentprofile'"></studentProfile>
    <playground v-if="$route.name=='playground-ide'"></playground>
    <studentQuestions v-if="$route.name=='studentQuestions'"></studentQuestions>
    <assignModal v-if="$route.name=='classrooms-details'"></assignModal>
    <lessonLockedModal v-if="$route.name=='classrooms-details'"></lessonLockedModal>
    <approveModal v-if="$route.name=='submissions'"></approveModal>
    <allNotificationsDisplay v-if="$route.name=='allNotificationsDisplay'"></allNotificationsDisplay>
    <competition v-if="$route.name=='competition'"></competition>
    <curriculum v-if="$route.name=='curriculum'"></curriculum>
    <registerFree v-if="$route.name=='courses'"></registerFree>
    <schoolStyles v-if="$route.name=='schoolBusiness' || $route.name=='Home'"></schoolStyles>
    <helloCodeHeros v-if="$route.name=='schoolBusiness'" ></helloCodeHeros>
    <ModalstudentProfile v-if="$route.name=='Studentprofile' || $route.name=='teachers'"></ModalstudentProfile>
    <homeAmazingKidsStyle v-if="$route.name == 'Home'"></homeAmazingKidsStyle>
    <homeHelloSmoothy v-if="$route.name == 'Home' || $route.name=='schoolBusiness'"></homeHelloSmoothy>
    <SubCourses v-if="$route.name=='schoolBusiness'"></SubCourses>
    <projectOftheMonth v-if="$route.name=='courses'"></projectOftheMonth>
    <landingKsa v-if="$route.name=='landingKsa'|| $route.name=='ksaSchools'"></landingKsa>
    <homeCoursesSectionStyle v-if="$route.name == 'Home'"></homeCoursesSectionStyle>
    <homeTestimonialSectionStyle v-if="$route.name == 'Home'"></homeTestimonialSectionStyle>
    <childregister v-if="$route.name == 'childRegistration'"></childregister>
    <birthChild  v-if="$route.name == 'childRegistration'"></birthChild >
    <passwordChild  v-if="$route.name == 'childRegistration'"></passwordChild >
    <parentregister v-if="$route.name == 'parentRegistration'"></parentregister>
    <homeFooterSectionStyle ></homeFooterSectionStyle>
    <signInStyle v-if="$route.name=='Login' || $route.name=='examLogin'"></signInStyle>
    <!-- version 2  -->
    <recoverPassword v-if="$route.name=='Recoverpassword'"></recoverPassword>
    <emailSent v-if="$route.name=='EmailSent'"></emailSent>
    <createNewPassword v-if="$route.name=='NewPassword'"></createNewPassword>
    <recoveryCompleted v-if="$route.name=='RecoveryCompleted'"></recoveryCompleted>
    <codeSent v-if="$route.name=='CodeSent'"></codeSent>
    <coursesStyles v-if="$route.name=='courses'"></coursesStyles>
    <offerhellocode  v-if="$route.name=='memberShip'"/>
    <updateplan v-if="$route.name=='thankyou'"> </updateplan>
    <emailStyles v-if="$route.name =='EmailConfirme'"></emailStyles>
    <regestrationStyles v-if="$route.name =='parentRegistration'"></regestrationStyles>
    <regestrationphoneStyles  v-if="$route.name =='phoneConfirme'"></regestrationphoneStyles>
    <passwordParent v-if="$route.name =='createRegistration'"></passwordParent>
    <parentARstyles v-if="$route.name=='manageMyKids'"></parentARstyles>
    <parentAccountInfoStyle v-if="$route.name =='parentAccountInfo' || $route.name =='teacherAccountInfo' || $route.name =='schoolInfo' || $route.name=='memberShip' || $route.name=='manageMyKids'"></parentAccountInfoStyle>
    <studentProfileAr v-if="$route.name=='Studentprofile'"></studentProfileAr>
    <myWorldStyle v-if="$route.name == 'Myworld'"></myWorldStyle>
    <lessonsListStyle v-if="$route.name == 'lessonsList'"></lessonsListStyle>
    <teacherMoreDetailStyle v-if="$route.name == 'teacherMoreDetails'"></teacherMoreDetailStyle>
    <smoothyIdeStyle v-if="$route.name == 'playground-ide' || $route.name == 'web-ide'  || $route.name == 'teacher-ide'"></smoothyIdeStyle>
    <examinationArStyle v-if="$route.name=='registerExam'"></examinationArStyle>  
    <schoolStudentDetails v-if="$route.name=='studentDetails'"></schoolStudentDetails>  
    <gamingAr v-if="$route.name=='gamesShared'"></gamingAr> 
    <examArabicStyle v-if="$route.name=='examRegistration'"></examArabicStyle>
    <homeCommunity v-if="$route.name=='community'"></homeCommunity>
    <commentsCommunity v-if="$route.name=='communityComments' || $route.name == 'communityProfile'|| $route.name=='myFriends' || $route.name=='friendsView'"/>
    <Perks v-if="$route.name=='Perks'"></Perks>
    <Pricing v-if="$route.name=='Pricing'"></Pricing>
    <assessmentResult v-if="$route.name=='assessmentResult'" ></assessmentResult>
    <python_ide_ar v-if="$route.name=='python-ide'"></python_ide_ar>
    <communityfriend v-if="$route.name== 'myFriends'"></communityfriend>
    <notficationcommunity  v-if="$route.name== 'myFriends' ||  $route.name== 'community' || $route.name== 'communityProfile'"></notficationcommunity>
    <memoryGame v-if="$route.name== 'memoryGameStages'"></memoryGame>
     <draganddrop></draganddrop>
     <puzzle v-if="$route.name=='puzzleGame'"></puzzle>
    <adminSchools v-if="$route.name=='admin'"></adminSchools>
  </div>
</template>
<script>
import Register from '../../main/register/register.vue';

const homePageStyle = () =>
  import(/* webpackChunkName: "homepage-ar-style" */ "./common/homePage.vue");
const contactUsPageStyle = () =>
  import(/* webpackChunkName: "contact-ar-style" */ "./common/contact-us.vue");
const resetPassword = () =>
  import(
    /* webpackChunkName: "contact-ar-style" */ "./common/resetPassword.vue"
  );
const newPassword = () =>
  import(/* webpackChunkName: "contact-ar-style" */ "./common/newPassword.vue");
const loginStyle = () =>
  import(/* webpackChunkName: "login-ar-style" */ "./common/login.vue");
const headerStyle = () =>
  import(/* webpackChunkName: "header-ar-style" */ "./common/header.vue");
const signUpPageStyle = () =>
  import(/* webpackChunkName: "signUp-ar-style" */ "./common/signUp.vue");
  const classRoomsteacher = () =>
  import(
    /* webpackChunkName: "classrooms-ar-style" */ "./teacher/classroom.vue"
  );
  const adminSchools = () =>
  import(
    /* webpackChunkName: "classrooms-ar-style" */ "./teacher/adminSchools.vue"
  );
const classRoomsDetailsTeacher = () =>
  import(/* webpackChunkName: "classrooms-details-ar-style" */ "./teacher/classroom-details.vue");
  const studentProfile = () =>
  import(/* webpackChunkName: "classrooms-details-ar-style" */ "./teacher/studentProfile.vue");
   const studentQuestions = () =>
  import(/* webpackChunkName: "classrooms-details-ar-style" */ "./teacher/studentQuestions.vue");
const progressAssessment = () =>
  import(
    /* webpackChunkName: "progress-assessment-ar-style" */ "./teacher/progress-assessment.vue"
  );
const codeAssessment = () =>
  import(
    /* webpackChunkName: "code-assessment-ar-style" */ "./teacher/code-assessment.vue"
  );
const schoolTeachers = () =>
  import(
    /* webpackChunkName: "lesson-schoolTeachers-ar-style" */ "./school/teachers.vue"
  );
  const schoolStudent = () =>
  import(
    /* webpackChunkName: "lesson-schoolTeachers-ar-style" */ "./school/student.vue"
  );
const manageMyKids = () =>
  import(
    /* webpackChunkName: "lesson-manageMyKids-ar-style" */ "./parent/manageMyKids.vue"
  );
  const helloCodeHeros=()=> import( /* webpackChunkName: "lesson-manageMyKids-ar-style" */ "./common/helloCodeHeros.vue");
const memberShip = () =>
  import(
    /* webpackChunkName: "lesson-memberShip-ar-style" */ "./parent/memberShip.vue"
  );
const renewSubscription = () =>
  import(
    /* webpackChunkName: "lesson-renewSubscription-ar-style" */ "./parent/renewSubscription.vue"
  );
const questionsPage = () =>
  import(
    /* webpackChunkName: "lesson-submissionsAndReviews-ar-style" */ "./student/ide-questions.vue"
  );
const ideStyle = () =>
  import(
    /* webpackChunkName: "lesson-submissionsAndReviews-ar-style" */ "./student/ide.vue"
  );
const lessonPrevideo = () =>
  import(
    /* webpackChunkName: "lesson-submissionsAndReviews-ar-style" */ "./student/lessonPrevideo.vue"
  );
  const assignModal = () =>
  import(
    /* webpackChunkName: "lesson-submissionsAndReviews-ar-style" */ "./teacher/assignModal.vue"
  );
  const lessonLockedModal = () =>
  import(
    /* webpackChunkName: "lesson-submissionsAndReviews-ar-style" */ "./teacher/lessonLockedModal.vue"
  );
    const approveModal = () =>
  import(
    /* webpackChunkName: "lesson-submissionsAndReviews-ar-style" */ "./teacher/approveModal.vue"
  );
      const allNotificationsDisplay = () =>
  import(
    /* webpackChunkName: "lesson-submissionsAndReviews-ar-style" */ "./student/allNotificationsDisplay.vue"
  );
    const competition = () =>
  import(
    /* webpackChunkName: "competition-ar-style" */ "./common/competition.vue"
  );
const playground = () =>
  import(/* webpackChunkName: "playground" */ "./student/playground.vue");
   const curriculum = () =>
  import(
    /* webpackChunkName: "competition-ar-style" */ "./common/curriculum.vue"
  );
  const registerFree= () =>
  import(
    /* webpackChunkName: "registerFree-ar-style" */ "./common/registerFree.vue"
  );
  
  const ModalstudentProfile = () =>
  import(
    /* webpackChunkName: "competition-ar-style" */ "./student/ModalstudentProfile.vue"
  );
  const assessmentResult =() => import ("./student/assessmentResult.vue");
  const python_ide_ar =() => import ("./student/python_ide_ar.vue")
      const schoolStyles = () =>
  import(
    /* webpackChunkName: "schoolStyles-ar-style" */ "./forBusiness/schoolStyles.vue"
  );
  
// new component v2
const homeAmazingKidsStyle = () =>
  import(
    /* webpackChunkName: "homepage-amazingkids-ar-style" */ "./common/homeAmazingKids.vue"
  );
 
  const homeHelloSmoothy =() => 
  import (
     /* webpackChunkName: "homepage-homeHelloSmoothy-ar-style" */ "./common/homeHelloSmoothy.vue"

  );
   const landingKsa = () =>
  import(
    /* webpackChunkName: "competition-ar-style" */ "./common/landingKsa.vue"
  );
  const SubCourses=()=>
  import(/* webpackChunkName: "competition-ar-style" */ "./common/SubCourses.vue");
const homeCoursesSectionStyle = () =>
  import(
    /* webpackChunkName: "homepage-CoursesSection-ar-style" */ "./common/homeCoursesSection.vue"
  );
  
  const projectOftheMonth=()=>
  import(
    /* webpackChunkName: "projectOftheMonth-ar-style" */ "./common/projectOftheMonth.vue"
  );
  const childregister =()=>
  import(
    /* webpackChunkName: "RegisterChild-ar-style" */ "./common/Registerchild.vue"
  );
  const birthChild =()=>
  import(
    /* webpackChunkName: "RegisterChild-ar-style" */ "./common/birthChild.vue"
  );
  const passwordChild =()=>
  import(
    /* webpackChunkName: "RegisterChild-ar-style" */ "./common/passwordChild.vue"
  );
        const parentARstyles = () =>
  import(
    /* webpackChunkName: "parentARstyles-ar-style" */ "./parent/parentARstyles.vue"
  );

   const parentregister =()=>
  import(
    /* webpackChunkName: "parentChild-ar-style" */ "./common/parentRegister.vue"
  );

const updateplan = () =>
  import(
    /* webpackChunkName: "homepage-amazingkids-ar-style" */ "./common/thankyou.vue"
  );

const homeTestimonialSectionStyle = () => import("./common/homeTestimonialSection.vue");
const homeFooterSectionStyle = () => import("./common/homeFooterSection.vue");
const signInStyle = () => import("./common/signinStyle.vue");
// version 2 recover Password
const recoverPassword = () => import("./common/recoverPasswordStyle.vue");
const emailSent = () => import("./common/emailSentStyle.vue");
const createNewPassword = () => import("./common/createNewPasswordStyle.vue");
const recoveryCompleted =() => import("./common/recoveryCompletedStyle.vue");
const codeSent = () => import("./common/codeSentStyle.vue");
      const coursesStyles = () =>
  import(
    /* webpackChunkName: "coursesStyles-ar-style" */ "./forBusiness/coursesStyles.vue"
  );
        const regestrationStyles = () =>
  import(
    /* webpackChunkName: "regestrationStyles-ar-style" */ "./forBusiness/regestrationStyles.vue"
  );
  const emailStyles = () =>
  import(
    /* webpackChunkName: "regestrationStyles-ar-style" */ "./forBusiness/emailConfirmation.vue"
  );
         const regestrationphoneStyles = () =>
  import(
    /* webpackChunkName: "regestrationStyles-ar-style" */ "./forBusiness/phoneNumberConfirmation.vue"
  );
         const passwordParent = () =>
  import(
    /* webpackChunkName: "regestrationStyles-ar-style" */ "./forBusiness/passwordParent.vue"
  );
  const offerhellocode = () =>
  import(
    /* webpackChunkName: "regestrationStyles-ar-style" */ "./common/offerhellocode.vue"
  );

// parent account info arabic style 
const parentAccountInfoStyle = () => import("./parent/accountInfoStyle.vue");
const studentProfileAr = () => import("./student/student-profile.vue");
// kid Dashboard => myWorld arabic style
const myWorldStyle = () => import("./student/myWorldStyle.vue");
const lessonsListStyle = () => import("./student/lessonsListStyle.vue");
//school top students arabic style 
const smoothyIdeStyle = () => import("./student/smoothyIdeStyle.vue");
    const schoolStudentDetails = () => import(
  "./school/schoolStudentDetails.vue"
  );


  // jonior games in Arabic 
  const gamingAr = () => import(
  "./common/gamingAr.vue"
  );

  const examinationArStyle = () => import(
  "./student/examinationArStyle.vue"
  );
// teacher details arabic style
const teacherMoreDetailStyle = () => import("./school/teacherMoreDetailStyle.vue")

// Examaination Home Page Arabic Styles
const examArabicStyle = () => import("./common/examArabicStyle.vue");
const homeCommunity = () => import("./community/homeCommunity.vue");
const commentsCommunity = () => import("./community/commentsCommunity.vue");
const Perks =() => import("./student/Perks.vue");
const Pricing =() => import("./student/Pricing.vue");
const communityfriend =() => import ("./common/communityfriend.vue")
const notficationcommunity  =() => import ("./community/notficationcommunity.vue")
const memoryGame = () =>import("./student/memoryGame.vue");
const draganddrop  =() => import ("./games/draganddrop.vue")
const puzzle =() => import ("./games/puzzle.vue")
export default {
  components: {
    homePageStyle,
    gamingAr,
    // pricingPageStyle,
    contactUsPageStyle,
    resetPassword,
    // version 2
    recoverPassword,
    emailSent,
    newPassword,
    createNewPassword,
    recoveryCompleted,
    codeSent,
    loginStyle,
    signInStyle,
    signUpPageStyle,
    headerStyle,
    classRoomsteacher,
    classRoomsDetailsTeacher,
    progressAssessment,
    codeAssessment,
    schoolTeachers,
    schoolStudent,
    manageMyKids,
    memberShip,
    renewSubscription,
    questionsPage,
    lessonPrevideo,
    ideStyle,
    playground,
    studentProfile,
    studentQuestions,
    assignModal,
    lessonLockedModal,
    approveModal,
    allNotificationsDisplay,
    competition,
    curriculum,
    ModalstudentProfile,
    schoolStyles,
    // new Home components V2
    homeAmazingKidsStyle,
    homeHelloSmoothy,
    landingKsa,
    SubCourses,
    homeCoursesSectionStyle,
    homeFooterSectionStyle,
    projectOftheMonth,
    homeTestimonialSectionStyle,
    coursesStyles,
    Register,
    homeFooterSectionStyle,
    registerFree,
    childregister,
    birthChild,
    passwordChild,
    regestrationStyles,
    parentARstyles,
    parentregister,
    regestrationStyles,
    regestrationphoneStyles,
    passwordParent,
    offerhellocode,
    updateplan,
    parentAccountInfoStyle,
    studentProfileAr,
    myWorldStyle,
    lessonsListStyle,
    helloCodeHeros,
    emailStyles,
    smoothyIdeStyle,
    teacherMoreDetailStyle,
    classRoomsDetailsTeacher,
    schoolStudentDetails,
    examinationArStyle,
    examArabicStyle,
    Perks,
    assessmentResult,
    python_ide_ar,
    homeCommunity,
    commentsCommunity,
    communityfriend,
    notficationcommunity,
    memoryGame,
    draganddrop,
    Pricing,
    puzzle,
    adminSchools
    

  },
};
</script>



// WEBPACK FOOTER //
// src/components/localStyle/ar/main.vue